import { styled, RadioGroup as RadioGroupBase } from '@mui/material'

export const RadioGroup = styled(RadioGroupBase)<{ direction?: 'column' | 'row' }>(
  ({ theme, direction = 'column' }) => ({
    background: theme.palette.common.white,
    borderRadius: '4px 4px 0 0',
    width: '100%',
    flexDirection: direction,
    flexWrap: direction === 'row' ? 'nowrap' : 'wrap',
  })
)
